export default __webpack_public_path__ + "static/media/XClosed.61310e23.jpg";